import React from 'react';
import { motion } from 'motion/react';
import { ArrowRight, MapPin, Play, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const highlights = [
  { value: '21', label: 'Years shaping premium addresses' },
  { value: '48', label: 'Delivered residences and workspaces' },
  { value: '96%', label: 'Referral-driven private enquiries' },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden pb-20 pt-36 md:pb-28 md:pt-44">
      <div className="paper-grid absolute inset-0 opacity-[0.32]" />
      <div className="floating-orb absolute left-[-6rem] top-16 h-64 w-64 rounded-full bg-accent/15" />
      <div className="floating-orb absolute right-[-8rem] top-28 h-72 w-72 rounded-full bg-primary/[0.08]" />

      <div className="section-shell relative">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(360px,0.95fr)] lg:items-end">
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-3xl"
          >
            <h1 className="text-balance text-5xl leading-[0.92] sm:text-6xl lg:text-[5.65rem]">
              Homes that feel like <span className="gold-text-gradient">private landmarks</span>.
            </h1>

            <p className="mt-8 max-w-2xl text-lg leading-8 text-secondary/68 md:text-xl">
              Suraksha Builders &amp; Developers designs residences and commercial addresses
              with the composure of boutique hospitality, the rigor of architecture, and the
              patience of long-term land stewardship.
            </p>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link
                to="/projects"
                className="inline-flex items-center justify-center gap-3 rounded-full bg-accent px-7 py-4 text-[11px] font-semibold uppercase tracking-[0.28em] text-secondary transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-light hover:text-primary"
              >
                Explore Projects
                <ArrowRight size={16} />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-3 rounded-full border border-white/10 bg-white/6 px-7 py-4 text-[11px] font-semibold uppercase tracking-[0.28em] text-secondary transition-all duration-300 hover:border-accent/40 hover:text-accent"
              >
                Book a Private Walkthrough
              </Link>
            </div>

            <div className="mt-14 grid gap-4 sm:grid-cols-3">
              {highlights.map((item) => (
                <div key={item.label} className="soft-panel p-5">
                  <p className="font-serif text-4xl text-secondary">{item.value}</p>
                  <p className="mt-2 text-sm leading-6 text-secondary/55">{item.label}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 36 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="soft-panel p-4 md:p-5">
              <div className="relative aspect-[4/5] overflow-hidden rounded-[1.75rem]">
                <img
                  src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&q=80&w=2070"
                  alt="Contemporary Suraksha residence"
                  className="h-full w-full object-cover"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/55 via-primary/10 to-transparent" />

                <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-secondary/70 backdrop-blur">
                  <Sparkles size={14} className="text-accent" />
                  Signature Residence
                </div>

                <div className="absolute inset-x-5 bottom-5 rounded-[1.5rem] bg-white/10 p-6 shadow-[0_20px_40px_rgba(0,0,0,0.5)] backdrop-blur">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className=" text-[10px] font-semibold uppercase tracking-[0.28em] text-white">
                        Featured Address
                      </p>
                      <h2 className="mt-2 text-3xl text-secondary">Ridge Courtyard Villas</h2>
                      <div className="mt-4 flex items-center gap-3 text-sm text-white">
                        <MapPin size={16} className="text-accent" />
                        Rajanukunte, Bengaluru
                      </div>
                    </div>
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/12 text-secondary">
                      <Play size={16} className="translate-x-0.5 fill-current" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

           
            </motion.div>
        </div>
      </div>
    </section>
  );
}
